export default __webpack_public_path__ + "static/media/Path.1355e873.webp";